import React from "react";
import Loading from "./Loading";

const Button = (props) => (
  < >
    <button
      type={props.type}
      // disabled={props.loading ? props.loading : null}
      disabled={props.disabled}
      className={
        props.type === "submit"
          ? "btn btn-primary"
          : props.type === "button" && !props.isCanceled
            ? "btn btn-success"
            : props.type === "button" && props.isCanceled &&
            "btn btn-danger"
      }
      style={props.margin ? { margin: props.margin } : { margin: '5px' }}
      onClick={props.onClick}
    >
      {props.type === 'button' && !props.isCanceled && <span style={{ marginRight: '10px' }}><i className="fa fa-plus"></i></span>}
      {props.loading ? <Loading
        loading={props.loading}
        margin={"4px 32px 4px 32px"}
        size={20}
        color={"black"}
      /> : props.title}
    </button>
  </>
);

export default Button;
